import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[ospStepContent]',
  standalone: true,
})
export class StepContentDirective {
  constructor(public template: TemplateRef<unknown>) {
  }
}
